import { useEffect, useState } from "react";
import { Button, Col, Row } from "react-bootstrap";
import { useNavigate, useParams } from "react-router-dom";
import { getProgramMediaSingle, getProgramSingle } from "../../../../services/program";
import { emptyProgram, emptyProgramMedia, Program, ProgramMedia } from "../../../../interfaces/program";
import { t } from "i18next";
import { ProgramMediaComments } from "./program-media-comments";
import { LoadingSpinner } from "../../../general/loading-spinner";

export function ProgramMediaView() {
    const params: any = useParams();
    const navigate = useNavigate();

    const [program, setProgram] = useState<Program>(emptyProgram);
    const [programMedia, setProgramMedia] = useState<ProgramMedia>(emptyProgramMedia);
    const [loaded, setLoaded] = useState(false);

    useEffect(() => {
        getProgramMediaSingle(params.id)
            .then(response => {
                getProgramSingle(response.data.program_id)
                    .then(responseProgram => {
                        setProgram(responseProgram.data);
                        setProgramMedia(response.data);
                        setLoaded(true);
                    })
            });
    }, []);

    const handleClose = (event: any) => {
        event.preventDefault();
        window.close();
    }

    return (
        <div className="program-media-view-container">
            { !loaded && <LoadingSpinner /> }
            { loaded &&
                <Row>
                    <Col xs={12} md={6} lg={4}>
                        <div className="media-header">
                            <h2 className="program-name">{ program.name }</h2>
                            <h1 className="media-name">{ programMedia.name }</h1>
                        </div>
                        <div className="progam-media">
                            { programMedia.description.length > 0 &&
                                <div className="description">
                                    { programMedia.description }
                                </div>
                            }
                            { programMedia.media.length >0 &&
                                <div className="media">
                                    {
                                        ['image/png', 'image/jpeg'].includes(programMedia.media[0].mimetype) &&
                                        <img src={ programMedia.media[0].url } alt={ programMedia.media[0].name } />
                                    }
                                    {
                                        [
                                            'application/pdf', 'audio/*', 'application/vnd.ms-powerpoint',
                                            'application/vnd.openxmlformats-officedocument.presentationml.presentation',
                                            'application/vnd.apple.keynote', 'application/vnd.ms-excel',
                                            'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
                                            'application/vnd.apple.numbers', 'application/msword',
                                            'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
                                            'application/vnd.apple.pages', 'application/zip',
                                            'application/x-rar', 'text/plain'
                                        ].includes(programMedia.media[0].mimetype) &&
                                        <a
                                            href={ programMedia.media[0].url }
                                            target="_blank"
                                            rel="noopener noreferrer"
                                            className="btn btn-primary"
                                            title={ programMedia.media[0].name }
                                        >
                                            <i className="bi bi-cloud-download"></i> { t("Download") }
                                        </a>
                                    }
                                    {
                                        ['video/mp4'].includes(programMedia.media[0].mimetype) &&
                                        <video width="320" height="240" controls>
                                            <source src={ programMedia.media[0].url } type="video/mp4" />
                                        </video>
                                    }
                                </div>
                            }
                        </div>
                    </Col>
                    <Col xs={12} md={6} lg={8}>
                        { loaded && program.id && programMedia.id &&
                            <ProgramMediaComments program_id={ program.id } media_id={ programMedia.id } onClose={ handleClose } />
                        }
                    </Col>
                </Row>
            }
        </div>
    )
}